import { useNavigate } from "react-router-dom";
import { IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GoBackIcon } from "../Icons";
import { GoBackButtonStyled } from "./GoBackButton.styled";
import { useNavigationBlockerContext } from "../../contexts";

interface GoBackButtonProps {
  to?: string;
}

const GoBackButton: React.FC<GoBackButtonProps> = ({ to }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { confirmNavigation } = useNavigationBlockerContext();

  const handleClick = () => {
    const doNavigate = () => {
      if (to) {
        navigate(to);
      } else {
        navigate(-1);
      }
    };

    if (confirmNavigation) {
      confirmNavigation(doNavigate);
    } else {
      doNavigate();
    }
  };

  return (
    <GoBackButtonStyled onClick={handleClick}>
      <IconButton className="icon-button">
        <GoBackIcon width="16px" height="16px" />
      </IconButton>
      <Typography className="text">{t("goBack")}</Typography>
    </GoBackButtonStyled>
  );
};

export default GoBackButton;
